var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"mb-1",attrs:{"variant":"primary"},on:{"click":_vm.clearZone}},[_c('span',[_vm._v("Clear Zone")])]),_c('div',{attrs:{"id":"zoneMap"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }